import { MENA_BANNER_DISMISSED_KEY } from "./constants";

const readDismissed = () => {
  try {
    const stored = JSON.parse(
      window.sessionStorage.getItem(MENA_BANNER_DISMISSED_KEY)
    );

    return Array.isArray(stored && stored.redirectBannerDismissed)
      ? stored.redirectBannerDismissed
      : [];
  } catch {
    return [];
  }
};

export const isMenaBannerDismissed = countryCode =>
  readDismissed().includes(countryCode);

export const setMenaBannerDismissed = countryCode => {
  try {
    const dismissed = readDismissed();

    if (!dismissed.includes(countryCode)) {
      window.sessionStorage.setItem(
        MENA_BANNER_DISMISSED_KEY,
        JSON.stringify({ redirectBannerDismissed: [...dismissed, countryCode] })
      );
    }
  } catch {
    // sessionStorage unavailable; banner will reappear, which is acceptable
  }
};
